import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import QuIcon from '@quiqupltd/qu-react-sdk/lib/components/qu-icon';
import { store } from '@quiqupltd/quiqupjs';
import { Container, Header, Content } from './styles';
import { PICKUP, DROPOFF, RETURN } from '../../../../utils/constants';
import { RateExperience } from '../rate-experience/rate-experience';
import { RateThankYou } from '../rate-experience/rate-thankyou';
import { useRate } from '../../../../providers/rate.provider';

const TITLE = {
  pickup: 'Your order has been collected',
  dropoff: 'Your order has been delivered',
  return: 'Your driver has returned',
};

const SUBTITLE = {
  pickup: 'Collected',
  dropoff: 'Delivered',
  return: 'Driver returned',
};

const CompletedCardHeader = ({ date, onToggleOpenCard, type, orderId }) => {
  const setIsRateOpen = useRate()[1];

  const handleRateExperienceClick = () => {
    setIsRateOpen(isOpen => !isOpen);
    onToggleOpenCard();
  };

  const hasAlreadyRated = store.get(`rated-${orderId}`);

  return (
    <Container>
      <Header onClick={onToggleOpenCard}>
        <div>
          <h1>{TITLE[type]}</h1>
          {!!date && (
            <Content>
              {SUBTITLE[type]} on {format(date, 'Do MMMM YYYY')}
            </Content>
          )}
        </div>

        <QuIcon icon="chevron-up" width={20} height={20} />
      </Header>

      {hasAlreadyRated ? <RateThankYou /> : <RateExperience onClick={handleRateExperienceClick} />}
    </Container>
  );
};

CompletedCardHeader.propTypes = {
  orderId: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  onToggleOpenCard: PropTypes.func.isRequired,
  type: PropTypes.oneOf([PICKUP, DROPOFF, RETURN]).isRequired,
};

export default CompletedCardHeader;



// WEBPACK FOOTER //
// ./src/app/order-card/completed/header/CompletedCardHeader.js